let nameReplace = function(name) {
    let regex = /\B[A-ZÀ-ÖØ-öø-ÿ]*/g;
    return name.replace(regex, newName => newName.toLowerCase());
};

export default nameReplace;